/* ==========================================================================
   BOUNTEOUS CONFIDENTIAL
   ___________________

   Copyright 2019 Bounteous
   All Rights Reserved.

   NOTICE:  All information contained herein is, and remains the property
   of Bounteous and its suppliers, if any. The intellectual and
   technical concepts contained herein are proprietary to Bounteous
   and its suppliers and are protected by trade secret or copyright law.
   Dissemination of this information or reproduction of this material
   is strictly forbidden unless prior written permission is obtained
   from Bounteous.
   ========================================================================== */

import { breakpointQueries } from '@RockwellAutomation/rockwell-meteor/breakpoints.js';

export const getBreakpointMediaQuery = (direction, breakpoint) => window.matchMedia(breakpointQueries[direction](breakpoint));

export const euCountries = [
    'Albania',
    'Åland Islands',
    'Algeria',
    'Andorra',
    'Angola',
    'Armenia',
    'Austria',
    'Bahrain',
    'Belarus',
    'Belgium',
    'Benin',
    'Bosnia and Herzegovina',
    'Botswana',
    'Bouvet Island',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Cameroon',
    'Cape Verde',
    'Central African Republic',
    'Chad',
    'Congo',
    'Congo, Democratic Republic',
    'Croatia',
    'Cyprus',
    'Czech Republic',
    'Denmark',
    'Djibouti',
    'Egypt',
    'Equatorial Guinea',
    'Eritrea',
    'Estonia',
    'Ethiopia',
    'European Union',
    'Faroe Islands',
    'Finland',
    'France',
    'Gabon',
    'Gambia',
    'Georgia',
    'Germany',
    'Ghana',
    'Gibraltar',
    'Greece',
    'Guinea',
    'Guinea-Bissau',
    'Guernsey',
    'Hungary',
    'Iceland',
    'Iran',
    'Iraq',
    'Ireland',
    'Isle of Man',
    'Israel',
    'Italy',
    'Ivory Coast',
    'Jersey',
    'Jordan',
    'Kenya',
    'Kuwait',
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liberia',
    'Libya',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'North Macedonia',
    'Madagascar',
    'Malawi',
    'Maldives',
    'Mali',
    'Malta',
    'Mauritania',
    'Mauritius',
    'Mayotte',
    'Moldova',
    'Monaco',
    'Montenegro',
    'Morocco',
    'Mozambique',
    'Namibia',
    'Netherlands',
    'Netherlands Antilles',
    'Niger',
    'Nigeria',
    'Norway',
    'Oman',
    'Palestine',
    'Poland',
    'Portugal',
    'Qatar',
    'Réunion',
    'Romania',
    'Russia',
    'Rwanda',
    'San Marino',
    'São Tomé and Príncipe',
    'Saudi Arabia',
    'Senegal',
    'Serbia',
    'Serbia and Montenegro',
    'Seychelles',
    'Sierra Leone',
    'Slovakia',
    'Slovenia',
    'Somalia',
    'South Africa',
    'Spain',
    'Saint Helena',
    'South Sudan',
    'Sudan',
    'Swaziland',
    'Sweden',
    'Switzerland',
    'Syria',
    'Tanzania',
    'Togo',
    'Tunisia',
    'Turkey',
    'Uganda',
    'Ukraine',
    'United Arab Emirates',
    'United Kingdom',
    'Vatican',
    'Western Sahara',
    'Yemen',
    'Zambia',
    'Zimbabwe',
    'Azerbaijan',
    'Kazakhstan',
    'Uzbekistan',
    'Kosovo',
];

export const countryToStatesMap = {
    'United States': [
        { name: 'Alabama', code: 'AL' },
        { name: 'Alaska', code: 'AK' },
        { name: 'American Samoa', code: 'AS' },
        { name: 'Arizona', code: 'AZ' },
        { name: 'Arkansas', code: 'AR' },
        { name: 'California', code: 'CA' },
        { name: 'Colorado', code: 'CO' },
        { name: 'Connecticut', code: 'CT' },
        { name: 'Delaware', code: 'DE' },
        { name: 'District Of Columbia', code: 'DC' },
        { name: 'Florida', code: 'FL' },
        { name: 'Georgia', code: 'GA' },
        { name: 'Guam', code: 'GU' },
        { name: 'Hawaii', code: 'HI' },
        { name: 'Idaho', code: 'ID' },
        { name: 'Illinois', code: 'IL' },
        { name: 'Indiana', code: 'IN' },
        { name: 'Iowa', code: 'IA' },
        { name: 'Kansas', code: 'KS' },
        { name: 'Kentucky', code: 'KY' },
        { name: 'Louisiana', code: 'LA' },
        { name: 'Maine', code: 'ME' },
        { name: 'Maryland', code: 'MD' },
        { name: 'Massachusetts', code: 'MA' },
        { name: 'Michigan', code: 'MI' },
        { name: 'Minnesota', code: 'MN' },
        { name: 'Mississippi', code: 'MS' },
        { name: 'Missouri', code: 'MO' },
        { name: 'Montana', code: 'MT' },
        { name: 'Nebraska', code: 'NE' },
        { name: 'Nevada', code: 'NV' },
        { name: 'New Hampshire', code: 'NH' },
        { name: 'New Jersey', code: 'NJ' },
        { name: 'New Mexico', code: 'NM' },
        { name: 'New York', code: 'NY' },
        { name: 'North Carolina', code: 'NC' },
        { name: 'North Dakota', code: 'ND' },
        { name: 'Northern Mariana Islands', code: 'MP' },
        { name: 'Ohio', code: 'OH' },
        { name: 'Oklahoma', code: 'OK' },
        { name: 'Oregon', code: 'OR' },
        { name: 'Pennsylvania', code: 'PA' },
        { name: 'Puerto Rico', code: 'PR' },
        { name: 'Rhode Island', code: 'RI' },
        { name: 'South Carolina', code: 'SC' },
        { name: 'South Dakota', code: 'SD' },
        { name: 'Tennessee', code: 'TN' },
        { name: 'Texas', code: 'TX' },
        { name: 'Utah', code: 'UT' },
        { name: 'Vermont', code: 'VT' },
        { name: 'Virgin Islands', code: 'VI' },
        { name: 'Virginia', code: 'VA' },
        { name: 'Washington', code: 'WA' },
        { name: 'West Virginia', code: 'WV' },
        { name: 'Wisconsin', code: 'WI' },
        { name: 'Wyoming', code: 'WY' },
    ],
    Canada: [
        { name: 'Alberta', code: 'AB' },
        { name: 'British Columbia', code: 'BC' },
        { name: 'Manitoba', code: 'MB' },
        { name: 'New Brunswick', code: 'NB' },
        { name: 'Newfoundland and Labrador', code: 'NL' },
        { name: 'Northwest Territories', code: 'NT' },
        { name: 'Nova Scotia', code: 'NS' },
        { name: 'Nunavut', code: 'NU' },
        { name: 'Ontario', code: 'ON' },
        { name: 'Prince Edward Island', code: 'PE' },
        { name: 'Quebec', code: 'QC' },
        { name: 'Saskatchewan', code: 'SK' },
        { name: 'Yukon', code: 'YT' },
    ],
    Australia: [
        { name: 'Australian Capital Territory', code: 'ACT' },
        { name: 'New South Wales', code: 'NSW' },
        { name: 'Northern Territory', code: 'NT' },
        { name: 'Queensland', code: 'QLD' },
        { name: 'South Australia', code: 'SA' },
        { name: 'Tasmania', code: 'TAS' },
        { name: 'Victoria', code: 'VIC' },
        { name: 'Western Australia', code: 'WA' },
    ],
    'New Zealand': [
        { name: 'Auckland', code: 'AUK' },
        { name: 'Bay of Plenty', code: 'BOP' },
        { name: 'Canterbury', code: 'CAN' },
        { name: 'Chatham Islands Territory', code: 'CIT' },
        { name: 'Gisborne', code: 'GIS' },
        { name: "Hawke's Bay", code: 'HKB' },
        { name: 'Marlborough', code: 'MBH' },
        { name: 'Manawatu-Wanganui', code: 'MWT' },
        { name: 'Nelson', code: 'NSN' },
        { name: 'Northland', code: 'NTL' },
        { name: 'Otago', code: 'OTA' },
        { name: 'Southland', code: 'STL' },
        { name: 'Tasman', code: 'TAS' },
        { name: 'Taranaki', code: 'TKI' },
        { name: 'Wellington', code: 'WGN' },
        { name: 'Waikato', code: 'WKO' },
        { name: 'West Coast', code: 'WTC' },
    ],
    China: [
        { name: 'Anhui', code: 'AH' },
        { name: 'Beijing', code: 'BJ' },
        { name: 'Chongqing', code: 'CQ' },
        { name: 'Fujian', code: 'FJ' },
        { name: 'Gansu', code: 'GS' },
        { name: 'Guangdong', code: 'GD' },
        { name: 'Guangxi', code: 'GX' },
        { name: 'Guizhou', code: 'GZ' },
        { name: 'Hainan', code: 'HI' },
        { name: 'Hebei', code: 'HE' },
        { name: 'Heilongjiang', code: 'HL' },
        { name: 'Henan', code: 'HA' },
        { name: 'Hubei', code: 'HB' },
        { name: 'Hunan', code: 'HN' },
        { name: 'Inner Mongolia', code: 'NM' },
        { name: 'Jiangsu', code: 'JS' },
        { name: 'Jiangxi', code: 'JX' },
        { name: 'Jilin', code: 'JL' },
        { name: 'Liaoning', code: 'LN' },
        { name: 'Ningxia', code: 'NX' },
        { name: 'Qinghai', code: 'QH' },
        { name: 'Shaanxi', code: 'SN' },
        { name: 'Shandong', code: 'SD' },
        { name: 'Shanghai', code: 'SH' },
        { name: 'Shanxi', code: 'SX' },
        { name: 'Sichuan', code: 'SC' },
        { name: 'Tianjin', code: 'TJ' },
        { name: 'Tibet', code: 'XZ' },
        { name: 'Xinjiang', code: 'XJ' },
        { name: 'Yunnan', code: 'YN' },
        { name: 'Zhejiang', code: 'ZJ' },
    ],
    India: [
        { name: 'Andaman and Nicobar Islands', code: 'AN' },
        { name: 'Andhra Pradesh', code: 'AP' },
        { name: 'Arunachal Pradesh', code: 'AR' },
        { name: 'Assam', code: 'AS' },
        { name: 'Bihar', code: 'BR' },
        { name: 'Chandigarh', code: 'CH' },
        { name: 'Chhattisgarh', code: 'CG' },
        { name: 'Dadra and Nagar Haveli and Daman and Diu', code: 'DN' },
        { name: 'Delhi', code: 'DL' },
        { name: 'Goa', code: 'GA' },
        { name: 'Gujarat', code: 'GJ' },
        { name: 'Haryana', code: 'HR' },
        { name: 'Himachal Pradesh', code: 'HP' },
        { name: 'Jammu and Kashmir', code: 'JK' },
        { name: 'Jharkhand', code: 'JH' },
        { name: 'Karnataka', code: 'KA' },
        { name: 'Kerala', code: 'KL' },
        { name: 'Ladakh', code: 'LA' },
        { name: 'Lakshadweep', code: 'LD' },
        { name: 'Madhya Pradesh', code: 'MP' },
        { name: 'Maharashtra', code: 'MH' },
        { name: 'Manipur', code: 'MN' },
        { name: 'Meghalaya', code: 'ML' },
        { name: 'Mizoram', code: 'MZ' },
        { name: 'Nagaland', code: 'NL' },
        { name: 'Odisha', code: 'OR' },
        { name: 'Puducherry', code: 'PY' },
        { name: 'Punjab', code: 'PB' },
        { name: 'Rajasthan', code: 'RJ' },
        { name: 'Sikkim', code: 'SK' },
        { name: 'Tamil Nadu', code: 'TN' },
        { name: 'Telangana', code: 'TG' },
        { name: 'Tripura', code: 'TR' },
        { name: 'Uttar Pradesh', code: 'UP' },
        { name: 'Uttarakhand', code: 'UK' },
        { name: 'West Bengal', code: 'WB' },
    ],
    Argentina: [
        { name: 'Buenos Aires', code: 'Buenos Aires' },
        { name: 'Catamarca', code: 'Catamarca' },
        { name: 'Chaco', code: 'Chaco' },
        { name: 'Chubut', code: 'Chubut' },
        { name: 'Corrientes', code: 'Corrientes' },
        {
            name: 'Ciudad Autónoma de Buenos Aires',
            code: 'Ciudad Autónoma de Buenos Aires',
        },
        { name: 'Córdoba', code: 'Córdoba' },
        { name: 'Entre Ríos', code: 'Entre Ríos' },
        { name: 'Formosa', code: 'Formosa' },
        { name: 'Jujuy', code: 'Jujuy' },
        { name: 'La Pampa', code: 'La Pampa' },
        { name: 'La Rioja', code: 'La Rioja' },
        { name: 'Mendoza', code: 'Mendoza' },
        { name: 'Misiones', code: 'Misiones' },
        { name: 'Neuquén', code: 'Neuquén' },
        { name: 'Salta', code: 'Salta' },
        { name: 'San Juan', code: 'San Juan' },
        { name: 'San Luis', code: 'San Luis' },
        { name: 'Santa Cruz', code: 'Santa Cruz' },
        { name: 'Santa Fe', code: 'Santa Fe' },
        { name: 'Santiago del Estero', code: 'Santiago del Estero' },
        { name: 'Tierra del Fuego', code: 'Tierra del Fuego' },
        { name: 'Tucumán', code: 'Tucumán' },
    ],
    Bolivia: [
        { name: 'Chuquisaca', code: 'Chuquisaca' },
        { name: 'Cochabamba', code: 'Cochabamba' },
        { name: 'El Beni', code: 'El Beni' },
        { name: 'La Paz', code: 'La Paz' },
        { name: 'Oruro', code: 'Oruro' },
        { name: 'Pando', code: 'Pando' },
        { name: 'Potosí', code: 'Potosí' },
        { name: 'Santa Cruz', code: 'Santa Cruz' },
        { name: 'Tarija', code: 'Tarija' },
    ],
    Brazil: [
        { name: 'Acre', code: 'AC' },
        { name: 'Alagoas', code: 'AL' },
        { name: 'Amapá', code: 'AP' },
        { name: 'Amazonas', code: 'AM' },
        { name: 'Bahia', code: 'BA' },
        { name: 'Ceará', code: 'CE' },
        { name: 'Distrito Federal', code: 'DF' },
        { name: 'Espírito Santo', code: 'ES' },
        { name: 'Goias', code: 'GO' },
        { name: 'Maranhão', code: 'MA' },
        { name: 'Mato Grosso', code: 'MT' },
        { name: 'Mato Grosso do Sul', code: 'MS' },
        { name: 'Minas Gerais', code: 'MG' },
        { name: 'Pará', code: 'PA' },
        { name: 'Paraíba', code: 'PB' },
        { name: 'Paraná', code: 'PR' },
        { name: 'Pernambuco', code: 'PE' },
        { name: 'Piauí', code: 'PI' },
        { name: 'Rio de Janeiro', code: 'RJ' },
        { name: 'Rio Grande do Norte', code: 'RN' },
        { name: 'Rio Grande do Sul', code: 'RS' },
        { name: 'Rondônia', code: 'RO' },
        { name: 'Roraima', code: 'RR' },
        { name: 'Santa Catarina', code: 'SC' },
        { name: 'Sao Paulo', code: 'SP' },
        { name: 'Sergipe', code: 'SE' },
        { name: 'Tocantins', code: 'TO' },
    ],
    Chile: [
        { name: 'Aisén del General Carlos Ibáñez del Campo', code: 'AI' },
        { name: 'Antofagasta', code: 'AN' },
        { name: 'Araucanía', code: 'AR' },
        { name: 'Arica y Parinacota', code: 'AP' },
        { name: 'Atacama', code: 'AT' },
        { name: 'Bío-Bío', code: 'BI' },
        { name: 'Coquimbo', code: 'CO' },
        { name: "Libertador General Bernardo O'Higgins", code: 'LI' },
        { name: 'Los Lagos', code: 'LL' },
        { name: 'Los Ríos', code: 'LR' },
        { name: 'Magallanes', code: 'MA' },
        { name: 'Maule', code: 'ML' },
        { name: 'Region Metropolitana de Santiago', code: 'RM' },
        { name: 'Tarapaca', code: 'TA' },
        { name: 'Valparaíso', code: 'VS' },
    ],
    Colombia: [
        { name: 'Amazonas', code: 'AMA' },
        { name: 'Antioquia', code: 'ANT' },
        { name: 'Arauca', code: 'ARA' },
        { name: 'Atlantico', code: 'ATL' },
        { name: 'Bolivar', code: 'BOL' },
        { name: 'Boyacá', code: 'BOY' },
        { name: 'Caldas', code: 'CAL' },
        { name: 'Caquetá', code: 'CAQ' },
        { name: 'Casanare', code: 'CAS' },
        { name: 'Cauca', code: 'CAU' },
        { name: 'Cesar', code: 'CES' },
        { name: 'Chocó', code: 'CHO' },
        { name: 'Córdoba', code: 'COR' },
        { name: 'Cundinamarca', code: 'CUN' },
        { name: 'Distrito Capital de Bogotá', code: 'DC' },
        { name: 'Guainía', code: 'GUA' },
        { name: 'Guaviare', code: 'GUV' },
        { name: 'Huila', code: 'HUI' },
        { name: 'La Guajira', code: 'LAG' },
        { name: 'Magdalena', code: 'MAG' },
        { name: 'Meta', code: 'MET' },
        { name: 'Nariño', code: 'NAR' },
        { name: 'Norte de Santander', code: 'NSA' },
        { name: 'Putumayo', code: 'PUT' },
        { name: 'Quindio', code: 'QUI' },
        { name: 'Risaralda', code: 'RIS' },
        { name: 'San Andres y Providencia', code: 'SAP' },
        { name: 'Santander', code: 'SAN' },
        { name: 'Sucre', code: 'SUC' },
        { name: 'Tolima', code: 'TOL' },
        { name: 'Valle del Cauca', code: 'VAC' },
        { name: 'Vaupés', code: 'VAU' },
        { name: 'Vichada', code: 'VID' },
    ],
    'Costa Rica': [
        { name: 'Alajuela', code: 'Alajuela' },
        { name: 'Cartago', code: 'Cartago' },
        { name: 'Guanacaste', code: 'Guanacaste' },
        { name: 'Heredia', code: 'Heredia' },
        { name: 'Limon', code: 'Limon' },
        { name: 'Puntarenas', code: 'Puntarenas' },
        { name: 'San Jose', code: 'San Jose' },
    ],
    Ecuador: [
        { name: 'Azuay', code: 'Azuay' },
        { name: 'Bolívar', code: 'Bolívar' },
        { name: 'Cañar', code: 'Cañar' },
        { name: 'Carchi', code: 'Carchi' },
        { name: 'Chimborazo', code: 'Chimborazo' },
        { name: 'Cotopaxi', code: 'Cotopaxi' },
        { name: 'El Oro', code: 'El Oro' },
        { name: 'Esmeraldas', code: 'Esmeraldas' },
        { name: 'Galápagos', code: 'Galápagos' },
        { name: 'Guayas', code: 'Guayas' },
        { name: 'Imbabura', code: 'Imbabura' },
        { name: 'Loja', code: 'Loja' },
        { name: 'Los Ríos', code: 'Los Ríos' },
        { name: 'Manabí', code: 'Manabí' },
        { name: 'Morona-Santiago', code: 'Morona-Santiago' },
        { name: 'Napo', code: 'Napo' },
        { name: 'Orellana', code: 'Orellana' },
        { name: 'Pastaza', code: 'Pastaza' },
        { name: 'Pichincha', code: 'Pichincha' },
        { name: 'Santa Elena', code: 'Santa Elena' },
        {
            name: 'Santo Domingo de los Tsáchilas',
            code: 'Santo Domingo de los Tsáchilas',
        },
        { name: 'Sucumbíos', code: 'Sucumbíos' },
        { name: 'Tungurahua', code: 'Tungurahua' },
        { name: 'Zamora-Chinchipe', code: 'Zamora-Chinchipe' },
    ],
    Guatemala: [
        { name: 'Alta Verapaz', code: 'AV' },
        { name: 'Baja Verapaz', code: 'BV' },
        { name: 'Chimaltenango', code: 'CM' },
        { name: 'Chiquimula', code: 'CQ' },
        { name: 'El Progreso', code: 'PR' },
        { name: 'Escuintla', code: 'ES' },
        { name: 'Guatemala', code: 'GU' },
        { name: 'Huehuetenango', code: 'HU' },
        { name: 'Izabal', code: 'IZ' },
        { name: 'Jalapa', code: 'JA' },
        { name: 'Jutiapa', code: 'JU' },
        { name: 'Petén', code: 'PE' },
        { name: 'Quetzaltenango', code: 'QZ' },
        { name: 'Quiché', code: 'QC' },
        { name: 'Realhuleu', code: 'RE' },
        { name: 'Sacatepéquez', code: 'SA' },
        { name: 'San Marcos', code: 'SM' },
        { name: 'Santa Rosa', code: 'SR' },
        { name: 'Solalá', code: 'SO' },
        { name: 'Suchitepéquez', code: 'SU' },
        { name: 'Totonicapán', code: 'TO' },
        { name: 'Zacapa', code: 'ZA' },
    ],
    Honduras: [
        { name: 'Atlántida', code: 'AT' },
        { name: 'Choluteca', code: 'CH' },
        { name: 'Colón', code: 'CL' },
        { name: 'Comayagua', code: 'CM' },
        { name: 'Copán', code: 'CP' },
        { name: 'Cortés', code: 'CR' },
        { name: 'El Paraíso', code: 'EP' },
        { name: 'Francisco Morazán', code: 'FM' },
        { name: 'Gracias a Dios', code: 'GD' },
        { name: 'Intibucá', code: 'IN' },
        { name: 'Islas de la Bahía', code: 'IB' },
        { name: 'La Paz', code: 'LP' },
        { name: 'Lempira', code: 'LE' },
        { name: 'Ocotepeque', code: 'OC' },
        { name: 'Olancho', code: 'OL' },
        { name: 'Santa Bárbara', code: 'SB' },
        { name: 'Valle', code: 'VA' },
        { name: 'Yoro', code: 'YO' },
    ],
    Mexico: [
        { name: 'Aguascalientes', code: 'AGU' },
        { name: 'Baja California', code: 'BCN' },
        { name: 'Baja California Sur', code: 'BCS' },
        { name: 'Campeche', code: 'CAM' },
        { name: 'Chiapas', code: 'CHP' },
        { name: 'Chihuahua', code: 'CHH' },
        { name: 'Coahuila de Zaragoza', code: 'COA' },
        { name: 'Colima', code: 'COL' },
        { name: 'Distrito Federal', code: 'DIF' },
        { name: 'Durango', code: 'DUR' },
        { name: 'Guanajuato', code: 'GUA' },
        { name: 'Guerrero', code: 'GRO' },
        { name: 'Hidalgo', code: 'HID' },
        { name: 'Jalisco', code: 'JAL' },
        { name: 'México', code: 'MEX' },
        { name: 'Michoacán de Ocampo', code: 'MIC' },
        { name: 'Morelos', code: 'MOR' },
        { name: 'Nayarit', code: 'NAY' },
        { name: 'Nuevo León', code: 'NLE' },
        { name: 'Oaxaca', code: 'OAX' },
        { name: 'Puebla', code: 'PUE' },
        { name: 'Querétaro de Arteaga', code: 'QUE' },
        { name: 'Quintana Roo', code: 'ROO' },
        { name: 'San Luis Potosí', code: 'SLP' },
        { name: 'Sinaloa', code: 'SIN' },
        { name: 'Sonora', code: 'SON' },
        { name: 'Tabasco', code: 'TAB' },
        { name: 'Tamaulipas', code: 'TAM' },
        { name: 'Tlaxcala', code: 'TLA' },
        { name: 'Veracruz-Llave', code: 'VER' },
        { name: 'Yucatán', code: 'YUC' },
        { name: 'Zacatecas', code: 'ZAC' },
    ],
    Nicaragua: [
        { name: 'Atlántico Norte', code: 'AN' },
        { name: 'Atlántico Sur', code: 'AS' },
        { name: 'Boaco', code: 'BO' },
        { name: 'Carazo', code: 'CA' },
        { name: 'Chinandega', code: 'CI' },
        { name: 'Chontales', code: 'CO' },
        { name: 'Esteli', code: 'ES' },
        { name: 'Granada', code: 'GR' },
        { name: 'Jinotega', code: 'JI' },
        { name: 'León', code: 'LE' },
        { name: 'Madriz', code: 'MD' },
        { name: 'Managua', code: 'MN' },
        { name: 'Masaya', code: 'MS' },
        { name: 'Matagalpa', code: 'MT' },
        { name: 'Nueva Segovia', code: 'NS' },
        { name: 'Río San Juan', code: 'SJ' },
        { name: 'Rivas', code: 'RI' },
    ],
    Panama: [
        { name: 'Bocas del Toro', code: 'Bocas del Toro' },
        { name: 'Chiriqui', code: 'Chiriqui' },
        { name: 'Cocle', code: 'Cocle' },
        { name: 'Colón', code: 'Colón' },
        { name: 'Darien', code: 'Darien' },
        { name: 'Emberá', code: 'Emberá' },
        { name: 'Herrera', code: 'Herrera' },
        { name: 'Kuna Yala', code: 'Kuna Yala' },
        { name: 'Los Santos', code: 'Los Santos' },
        { name: 'Ngöbe-Buglé', code: 'Ngöbe-Buglé' },
        { name: 'Veraguas', code: 'Veraguas' },
    ],
    Peru: [
        { name: 'Amazonas', code: 'AMA' },
        { name: 'Ancash', code: 'ANC' },
        { name: 'Apurímac', code: 'APU' },
        { name: 'Arequipa', code: 'ARE' },
        { name: 'Ayacucho', code: 'AYA' },
        { name: 'Cajamarca', code: 'CAJ' },
        { name: 'Cusco', code: 'CUS' },
        { name: 'El Callao', code: 'CAL' },
        { name: 'Huancavelica', code: 'HUV' },
        { name: 'Huánuco', code: 'HUC' },
        { name: 'Ica', code: 'ICA' },
        { name: 'Junín', code: 'JUN' },
        { name: 'La Libertad', code: 'LAL' },
        { name: 'Lamayeque', code: 'LAM' },
        { name: 'Lima', code: 'LIM' },
        { name: 'Loreto', code: 'LOR' },
        { name: 'Madre de Dios', code: 'MDD' },
        { name: 'Moquegua', code: 'MOQ' },
        { name: 'Municipalidad Metropolitana de Lima', code: 'LMA' },
        { name: 'Pasco', code: 'PAS' },
        { name: 'Piura', code: 'PIU' },
        { name: 'Puno', code: 'PUN' },
        { name: 'San Martín', code: 'SAM' },
        { name: 'Tacna', code: 'TAC' },
        { name: 'Tumbes', code: 'TUM' },
        { name: 'Ucuyali', code: 'UCA' },
    ],
    'El Salvador': [
        { name: 'Ahuachapan', code: 'AH' },
        { name: 'Cabanas', code: 'CA' },
        { name: 'Chalatenango', code: 'CH' },
        { name: 'Cuscatlan', code: 'CU' },
        { name: 'La Libertad', code: 'LI' },
        { name: 'La Paz', code: 'PA' },
        { name: 'La Union', code: 'UN' },
        { name: 'Morazan', code: 'MO' },
        { name: 'San Miguel', code: 'SM' },
        { name: 'San Salvador', code: 'SS' },
        { name: 'San Vicente', code: 'SV' },
        { name: 'Santa Ana', code: 'SA' },
        { name: 'Sonsonate', code: 'SO' },
        { name: 'Usulutan', code: 'US' },
    ],
    Uruguay: [
        { name: 'Artigas', code: 'AR' },
        { name: 'Canelones', code: 'CA' },
        { name: 'Cerro Largo', code: 'CL' },
        { name: 'Colonia', code: 'CO' },
        { name: 'Durazno', code: 'DU' },
        { name: 'Flores', code: 'FS' },
        { name: 'Florida', code: 'FD' },
        { name: 'Lavalleja', code: 'LA' },
        { name: 'Maldonado', code: 'MA' },
        { name: 'Montevideo', code: 'MO' },
        { name: 'Paysandú', code: 'PA' },
        { name: 'Río Negro', code: 'RN' },
        { name: 'Rivera', code: 'RV' },
        { name: 'Rocha', code: 'RO' },
        { name: 'Salto', code: 'SA' },
        { name: 'San José', code: 'SJ' },
        { name: 'Soriano', code: 'SO' },
        { name: 'Tacuarembó', code: 'TA' },
        { name: 'Treinta y Tres', code: 'TT' },
    ],
    Venezuela: [
        { name: 'Amazonas', code: 'Amazonas' },
        { name: 'Anzoategui', code: 'Anzoategui' },
        { name: 'Apure', code: 'Apure' },
        { name: 'Aragua', code: 'Aragua' },
        { name: 'Barinas', code: 'Barinas' },
        { name: 'Bolívar', code: 'Bolívar' },
        { name: 'Carabobo', code: 'Carabobo' },
        { name: 'Cojedes', code: 'Cojedes' },
        { name: 'Delta Amacuro', code: 'Delta Amacuro' },
        { name: 'Dependencias Federales', code: 'Dependencias Federales' },
        { name: 'Distrito Federal', code: 'Distrito Federal' },
        { name: 'Falcón', code: 'Falcón' },
        { name: 'Guarico', code: 'Guarico' },
        { name: 'Lara', code: 'Lara' },
        { name: 'Mérida', code: 'Mérida' },
        { name: 'Mirinda', code: 'Mirinda' },
        { name: 'Monagas', code: 'Monagas' },
        { name: 'Nueva Esparta', code: 'Nueva Esparta' },
        { name: 'Portuguesa', code: 'Portuguesa' },
        { name: 'Sucre', code: 'Sucre' },
        { name: 'Tachira', code: 'Tachira' },
        { name: 'Trujillo', code: 'Trujillo' },
        { name: 'Vargas', code: 'Vargas' },
        { name: 'Yaracuy', code: 'Yaracuy' },
        { name: 'Zulia', code: 'Zulia' },
    ],
    'South Korea': [
        { name: 'Gangwon', code: 'GW' },
        { name: 'Gyeonggi', code: 'GG' },
        { name: 'Chungbuk', code: 'CB' },
        { name: 'Gyeongbuk', code: 'GB' },
        { name: 'Jeonbuk', code: 'JB' },
        { name: 'Chungnam', code: 'CN' },
        { name: 'Gyeongnam', code: 'GN' },
        { name: 'Jeonnam', code: 'JN' },
        { name: 'Seoul', code: 'SL' },
    ],
};

/**
 * ISO 3166-1 alpha-2 code → canonical English country name.
 *
 * Bridges authored option VALUES (which stay stable across language masters,
 * e.g. `US`, `CA`, `DE`) to the keys used by `countryToStatesMap` and the
 * entries in `euCountries` (which are English country names). Consumers that
 * need to drive country-conditional UI from the form's value should look up
 * `countryCodeToName[option.value]` rather than reading the option's visible
 * text (which gets translated and breaks the lookup).
 *
 * Limited to the union of codes for countries that appear in `euCountries`
 * (GDPR consent) and `countryToStatesMap` (sub-region picker). Codes for
 * other countries are intentionally omitted — they don't trigger any
 * conditional logic, so missing entries are a no-op.
 */
export const countryCodeToName = {
    /* countryToStatesMap members */
    US: 'United States',
    CA: 'Canada',
    AU: 'Australia',
    NZ: 'New Zealand',
    CN: 'China',
    IN: 'India',
    AR: 'Argentina',
    BO: 'Bolivia',
    BR: 'Brazil',
    CL: 'Chile',
    CO: 'Colombia',
    CR: 'Costa Rica',
    EC: 'Ecuador',
    GT: 'Guatemala',
    HN: 'Honduras',
    MX: 'Mexico',
    NI: 'Nicaragua',
    PA: 'Panama',
    PE: 'Peru',
    SV: 'El Salvador',
    UY: 'Uruguay',
    VE: 'Venezuela',
    KR: 'South Korea',
    /* euCountries members not already listed above */
    AL: 'Albania',
    AX: 'Åland Islands',
    DZ: 'Algeria',
    AD: 'Andorra',
    AO: 'Angola',
    AM: 'Armenia',
    AT: 'Austria',
    BH: 'Bahrain',
    BY: 'Belarus',
    BE: 'Belgium',
    BJ: 'Benin',
    BA: 'Bosnia and Herzegovina',
    BW: 'Botswana',
    BV: 'Bouvet Island',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    CM: 'Cameroon',
    CV: 'Cape Verde',
    CF: 'Central African Republic',
    TD: 'Chad',
    CG: 'Congo',
    CD: 'Congo, Democratic Republic',
    HR: 'Croatia',
    CY: 'Cyprus',
    CZ: 'Czech Republic',
    DK: 'Denmark',
    DJ: 'Djibouti',
    EG: 'Egypt',
    GQ: 'Equatorial Guinea',
    ER: 'Eritrea',
    EE: 'Estonia',
    ET: 'Ethiopia',
    EU: 'European Union',
    FO: 'Faroe Islands',
    FI: 'Finland',
    FR: 'France',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgia',
    DE: 'Germany',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Greece',
    GN: 'Guinea',
    GW: 'Guinea-Bissau',
    GG: 'Guernsey',
    HU: 'Hungary',
    IS: 'Iceland',
    IR: 'Iran',
    IQ: 'Iraq',
    IE: 'Ireland',
    IM: 'Isle of Man',
    IL: 'Israel',
    IT: 'Italy',
    CI: 'Ivory Coast',
    JE: 'Jersey',
    JO: 'Jordan',
    KE: 'Kenya',
    KW: 'Kuwait',
    LV: 'Latvia',
    LB: 'Lebanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libya',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MK: 'North Macedonia',
    MG: 'Madagascar',
    MW: 'Malawi',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malta',
    MR: 'Mauritania',
    MU: 'Mauritius',
    YT: 'Mayotte',
    MD: 'Moldova',
    MC: 'Monaco',
    ME: 'Montenegro',
    MA: 'Morocco',
    MZ: 'Mozambique',
    NA: 'Namibia',
    NL: 'Netherlands',
    AN: 'Netherlands Antilles',
    NE: 'Niger',
    NG: 'Nigeria',
    NO: 'Norway',
    OM: 'Oman',
    PS: 'Palestine',
    PL: 'Poland',
    PT: 'Portugal',
    QA: 'Qatar',
    RE: 'Réunion',
    RO: 'Romania',
    RU: 'Russia',
    RW: 'Rwanda',
    SM: 'San Marino',
    ST: 'São Tomé and Príncipe',
    SA: 'Saudi Arabia',
    SN: 'Senegal',
    RS: 'Serbia',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SK: 'Slovakia',
    SI: 'Slovenia',
    SO: 'Somalia',
    ZA: 'South Africa',
    ES: 'Spain',
    SH: 'Saint Helena',
    SS: 'South Sudan',
    SD: 'Sudan',
    SZ: 'Swaziland',
    SE: 'Sweden',
    CH: 'Switzerland',
    SY: 'Syria',
    TZ: 'Tanzania',
    TG: 'Togo',
    TN: 'Tunisia',
    TR: 'Turkey',
    UG: 'Uganda',
    UA: 'Ukraine',
    AE: 'United Arab Emirates',
    GB: 'United Kingdom',
    VA: 'Vatican',
    EH: 'Western Sahara',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
    AZ: 'Azerbaijan',
    KZ: 'Kazakhstan',
    UZ: 'Uzbekistan',
    XK: 'Kosovo',
};

export const regionToCountriesMap = {
    NA: [
        'American Samoa',
        'Canada',
        'Greenland',
        'Saint Kitts and Nevis',
        'Saint Pierre and Miquelon',
        'United States',
        'United States Minor Outlying Islands'
    ],
    LA: [
        'Anguilla',
        'Antigua and Barbuda',
        'Argentina',
        'Aruba',
        'Bahamas',
        'Barbados',
        'Belize',
        'Bermuda',
        'Bolivia',
        'Brazil',
        'Bonaire',
        'Cayman Islands',
        'Chile',
        'Cocos Islands',
        'Colombia',
        'Costa Rica',
        'Cuba',
        'Curacao',
        'Dominica',
        'Dominican Republic',
        'Ecuador',
        'El Salvador',
        'Falkland Islands',
        'French Guiana',
        'Grenada',
        'Guadeloupe',
        'Guatemala',
        'Guyana',
        'Haiti',
        'Honduras',
        'Jamaica',
        'Martinique',
        'Mexico',
        'Montserrat',
        'Saint Martin',
        'Nicaragua',
        'Panama',
        'Paraguay',
        'Peru',
        'Puerto Rico',
        'Saint Lucia',
        'Saint Vincent and the Grenadines',
        'Suriname',
        'Trinidad and Tobago',
        'Turks and Caicos Islands',
        'Uruguay',
        'Venezuela',
        'British Virgin Islands',
        'U.S. Virgin Islands'
    ],
    EMEA: [
        'Albania',
        'Aland Islands',
        'Algeria',
        'Andorra',
        'Angola',
        'Armenia',
        'Austria',
        'Bahrain',
        'Belarus',
        'Belgium',
        'Benin',
        'Bosnia and Herzegovina',
        'Botswana',
        'Bouvet Island',
        'Bulgaria',
        'Burkina Faso',
        'Burundi',
        'Cameroon',
        'Cape Verde',
        'Central African Republic',
        'Chad',
        'Republic of Congo',
        'Democratic Republic of the Congo',
        'Croatia',
        'Cyprus',
        'Czech Republic',
        'Denmark',
        'Djibouti',
        'Egypt',
        'Equatorial Guinea',
        'Eritrea',
        'Estonia',
        'Ethiopia',
        'European Union',
        'Faroe Islands',
        'Finland',
        'France',
        'Gabon',
        'Gambia',
        'Georgia',
        'Germany',
        'Ghana',
        'Gibraltar',
        'Greece',
        'Guinea',
        'Guinea-Bissau',
        'Guernsey',
        'Hungary',
        'Iceland',
        'Iran',
        'Iraq',
        'Ireland',
        'Isle of Man',
        'Israel',
        'Italy',
        'Ivory Coast',
        'Jersey',
        'Jordan',
        'Kenya',
        'Kuwait',
        'Latvia',
        'Lebanon',
        'Lesotho',
        'Liberia',
        'Libya',
        'Liechtenstein',
        'Lithuania',
        'Luxembourg',
        'Macedonia',
        'Madagascar',
        'Malawi',
        'Maldives',
        'Mali',
        'Malta',
        'Mauritania',
        'Mauritius',
        'Mayotte',
        'Moldova',
        'Monaco',
        'Montenegro',
        'Morocco',
        'Mozambique',
        'Namibia',
        'Netherlands',
        'Netherlands Antilles',
        'Niger',
        'Nigeria',
        'Norway',
        'Oman',
        'Palestine',
        'Poland',
        'Portugal',
        'Qatar',
        'Reunion',
        'Romania',
        'Russia',
        'Rwanda',
        'San Marino',
        'Sao Tome and Principe',
        'Saudi Arabia',
        'Senegal',
        'Serbia',
        'Serbia and Montenegro',
        'Seychelles',
        'Sierra Leone',
        'Slovakia',
        'Slovenia',
        'Somalia',
        'South Africa',
        'Spain',
        'Saint Helena',
        'South Sudan',
        'Sudan',
        'Swaziland',
        'Sweden',
        'Switzerland',
        'Syria',
        'Tanzania',
        'Togo',
        'Tunisia',
        'Turkey',
        'Uganda',
        'Ukraine',
        'United Arab Emirates',
        'United Kingdom',
        'Vatican City',
        'Western Sahara',
        'Yemen',
        'Zambia',
        'Zimbabwe',
        'Azerbaijan',
        'Kazakhstan',
        'Uzbekistan',
        'Kosovo'
    ],
    APAC: [
        'Afghanistan',
        'Antarctica',
        'Australia',
        'Bangladesh',
        'Bhutan',
        'British Indian Ocean Territory',
        'Brunei',
        'Cambodia',
        'China',
        'Christmas Island',
        'Comoros',
        'Cook Islands',
        'Fiji',
        'French Polynesia',
        'French Southern Territories',
        'Guam',
        'Heard Island and McDonald Islands',
        'Hong Kong',
        'India',
        'Indonesia',
        'Japan',
        'Kiribati',
        'North Korea',
        'South Korea',
        'Kyrgyzstan',
        'Laos',
        'Macao',
        'Malaysia',
        'Marshall Islands',
        'Micronesia',
        'Mongolia',
        'Myanmar',
        'Northern Mariana Islands',
        'Nauru',
        'Nepal',
        'New Caledonia',
        'New Zealand',
        'Niue',
        'Norfolk Island',
        'Pakistan',
        'Palau',
        'Papua New Guinea',
        'Philippines',
        'Pitcairn',
        'Samoa',
        'Singapore',
        'Solomon Islands',
        'Sri Lanka',
        'Svalbard and Jan Mayen',
        'Taiwan',
        'Tajikistan',
        'Thailand',
        'Timor-Leste',
        'Tokelau',
        'Tonga',
        'Turkmenistan',
        'Tuvalu',
        'Vanuatu',
        'Vietnam',
        'Wallis and Futuna'
    ],
};

export const regionNotRequiredCountries = ['Japan'];
